import Icon from '../components/Icon.vue'

Icon.register({"truck":{"width":640,"height":512,"paths":[{"d":"M624 352H608V243.9C608 231.2 602.9 219 593.9 210L494 110.1C485 101.1 472.8 96 460.1 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V368C0 394.5 21.5 416 48 416H64C64 469 107 512 160 512S256 469 256 416H384C384 469 427 512 480 512S576 469 576 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM160 464C133.5 464 112 442.5 112 416S133.5 368 160 368 208 389.5 208 416 186.5 464 160 464zM480 464C453.5 464 432 442.5 432 416S453.5 368 480 368 528 389.5 528 416 506.5 464 480 464zM560 256H416V144H460.1L560 243.9V256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck.js
// module id = csso
// module chunks = 0